'use strict'

/**
 * Source-unit identity at the upstream-source API boundary.
 *
 * The database owns both the UUID and serialized physical identity. NetSuite
 * uses that persisted serial as the SKU; PlatformGold never fabricates a
 * source item internal id.
 */

export const hydrateSourceUnitIdentity = (unit) => {
  if (!unit || typeof unit !== 'object') throw new Error('source unit required')
  const serialNumber = String(unit.serialNumber || '').trim()
  if (!serialNumber) throw new Error('database serial required for source unit')
  if (unit.sku && String(unit.sku).trim() !== serialNumber) {
    throw new Error(`source sku must equal database serial: ${serialNumber}`)
  }
  const hydrated = {...unit}
  delete hydrated.netsuiteItemInternalId
  return {
    ...hydrated,
    serialNumber,
    sku: serialNumber,
  }
}

export const hydrateUpstreamSourceLotIdentity = (lot) => {
  if (!Array.isArray(lot?.units)) {
    throw new Error('upstream source lot units required')
  }
  return {
    ...lot,
    units: lot.units.map(hydrateSourceUnitIdentity),
  }
}
